import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAward = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    {...props}
  >
    <path
      fill='currentColor'
      d='M9.201 14.022a1 1 0 0 0-1.982-.264zM7 23l-.991-.132a1 1 0 0 0 1.505.99zm5-3 .515-.858a1 1 0 0 0-1.03 0zm5 3-.515.858a1 1 0 0 0 1.506-.99zm-.219-9.251a1 1 0 1 0-1.982.262zM18 8a6 6 0 0 1-6 6v2a8 8 0 0 0 8-8zm-6 6a6 6 0 0 1-6-6H4a8 8 0 0 0 8 8zM6 8a6 6 0 0 1 6-6V0a8 8 0 0 0-8 8zm6-6a6 6 0 0 1 6 6h2a8 8 0 0 0-8-8zM7.219 13.758l-1.21 9.11 1.982.264 1.21-9.11zm.295 10.1 5-3-1.028-1.716-5 3zm3.972-3 5 3 1.029-1.716-5-3zm6.505 2.01-1.21-9.12-1.982.264 1.21 9.12z'
    />
  </svg>
);
export default SvgAward;
